import React, { useEffect, useState } from 'react'
import { formatDistance } from 'date-fns'

import { addComment } from '../../utils/api'

import './styles/comment-section.scss'

const CommentSection = props => {
  const { comments, setComments, videoId } = props

  const [username, setUsername] = useState('')
  const [userComment, setUserComment] = useState('')

  const handleSubmit = e => {
    console.log('comment submitted')
    e.preventDefault()

    const name = username.trim()
    const comment = userComment.trim()

    if (name.length === 0 || comment.length === 0) return

    addComment(videoId, name, comment)
      .then(resp => console.log('ADD_COMMENT -> ', resp))

    const newCommentEntry = {
      name,
      comment,
      date: new Date(),
      id: Math.random()
    }

    setComments(prevState => [newCommentEntry, ...prevState])
  }

  return (
    <section className="comments-section">
      <header>
        <p className="comments-count highlighted">{comments.length} comments</p>
        <h3 className="title" id="comment-section-title">Add a Comment</h3>
      </header>

      <form
        aria-labelledby="comment-section-title"
        onSubmit={e => handleSubmit(e)}
      >
        <div className="input-wrapper">
          <input
            type="text"
            name="your-name"
            id="comment__your-name"
            className="input input--name"
            autoComplete="off"
            spellCheck="false"
            placeholder="Name"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
          <label htmlFor="comment__your-name">Name</label>
        </div>
        <div className="input-wrapper">
          <input
            type="text"
            name="your-comment"
            id="comment__your-comment"
            className="input input--comment"
            autoComplete="off"
            spellCheck="true"
            placeholder="What did you think?"
            value={userComment}
            onChange={e => setUserComment(e.target.value)}
          />
          <label htmlFor="comment__your-comment">What did you think?</label>
        </div>
        <button type="submit" className="visually-hidden" tabIndex="-1">
          submit
        </button>
      </form>
      <hr className="separator"/>
      <ul className="comments-list">
        {comments.map(comm => {
          const { id, name, comment, date } = comm

          const publishedAt = formatDistance(new Date(date), new Date(), {
            addSuffix: true,
          })

          return (
            <li className="comment-entry" key={id}>
              <article className="single-comment">
                <div className="single-comment-inner">
                  <header>
                    <h5 className="username">{name}</h5>
                    <time dateTime={date} className="posted">
                      {publishedAt}
                    </time>
                  </header>
                  <p className="content">
                    {comment}
                  </p>
                </div>
              </article>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default CommentSection